/*
 * BL-custom.js
 * Module: header-transparent
 * Scope: transition unlock and legacy PDP transparent-header cleanup only.
 * Module: nav-prefetch (al final del fichero)
 */

(function () {
  'use strict';

  var ACTIVE_CLASS = 'bl-header-transparent-active';
  var ACTIVE_EXIT_SCROLL = 28;
  var ACTIVE_ENTER_SCROLL = 4;
  var transparentStateActive = null;
  var transparentStateTicking = false;

  function hasTransparentHeader() {
    return Boolean(document.querySelector('header[data-enable-transparent="true"]'));
  }

  function shouldUseTransparentHysteresis() {
    if (!document.body) return false;
    return document.body.classList.contains('index-template') || document.body.classList.contains('product-template');
  }

  function updateTransparentState() {
    transparentStateTicking = false;
    if (!document.body || !hasTransparentHeader() || !shouldUseTransparentHysteresis()) return;

    var scrollTop = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    var nextActive = transparentStateActive;

    if (nextActive === null) {
      nextActive = scrollTop <= ACTIVE_EXIT_SCROLL;
    } else if (nextActive && scrollTop >= ACTIVE_EXIT_SCROLL) {
      nextActive = false;
    } else if (!nextActive && scrollTop <= ACTIVE_ENTER_SCROLL) {
      nextActive = true;
    }

    if (nextActive !== transparentStateActive) {
      transparentStateActive = nextActive;
      document.body.classList.toggle(ACTIVE_CLASS, nextActive);
    }
  }

  function requestTransparentStateUpdate() {
    if (transparentStateTicking) return;
    transparentStateTicking = true;
    requestAnimationFrame(updateTransparentState);
  }

  function enableHeaderTransitions() {
    if (!document.body) return;

    updateTransparentState();
    window.addEventListener('scroll', requestTransparentStateUpdate, { passive: true });
    window.addEventListener('resize', requestTransparentStateUpdate);
    document.addEventListener('shopify:section:load', requestTransparentStateUpdate);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.body.classList.add('bl-header-transition-ready');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableHeaderTransitions, { once: true });
  } else {
    enableHeaderTransitions();
  }
})();

(function () {
  'use strict';

  var BODY_CLASS = 'bl-pdp-header-force-transparent';

  function clearForcedTransparentState() {
    if (!document.body) return;
    document.body.classList.remove(BODY_CLASS);
  }

  document.addEventListener('shopify:section:load', clearForcedTransparentState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearForcedTransparentState, { once: true });
  } else {
    clearForcedTransparentState();
  }
})();

/*
 * Module: nav-prefetch (2026-10-09)
 * Precarga el HTML de la pagina siguiente cuando la intencion de ir a ella es clara, para que la
 * navegacion salga de la cache del navegador: la pagina 2 de una lista precargada pinto en ~120 ms
 * en vez de ~1 s (medido con tools/perf). Shopify ya precarga en Chrome al pasar el raton o al
 * pulsar (sus reglas "moderate"); esto cubre los casos con intencion ANTES del toque: la paginacion
 * cuando se acerca a la pantalla, los enlaces del menu movil al abrirlo (9 de cada 10 aperturas
 * acaban en un enlace) y las pastillas de combinacion al tocarlas. Solo Chrome/Edge (Speculation
 * Rules) y Firefox (<link rel=prefetch>); Safari no precarga paginas. Tope de 8 por pagina y nada
 * con ahorro de datos o red 2G.
 */
(function () {
  'use strict';

  var MAX_PREFETCHES = 8;
  var MENU_LINKS = 4;
  var done = Object.create(null);
  var count = 0;
  var conn = navigator.connection || {};
  if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;

  var supportsRules = typeof HTMLScriptElement !== 'undefined'
    && typeof HTMLScriptElement.supports === 'function'
    && HTMLScriptElement.supports('speculationrules');

  function prefetch(href) {
    if (!href || count >= MAX_PREFETCHES) return;
    var url;
    try { url = new URL(href, window.location.href); } catch (error) { return; }
    if (url.origin !== window.location.origin) return;
    url.hash = '';
    var key = url.href;
    if (done[key] || key === window.location.href.split('#')[0]) return;
    done[key] = true;
    count += 1;
    if (supportsRules) {
      var rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [key] }] });
      document.head.appendChild(rules);
    } else {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = key;
      document.head.appendChild(link);
    }
  }

  function closestLink(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('.pagination__item[href], .bl-combo-bar__pill[href]');
  }

  function init() {
    // paginacion: la pagina siguiente en cuanto el paginador se acerca a la pantalla
    var next = document.querySelector('.pagination__item--next[href]');
    if (next && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        prefetch(next.getAttribute('href'));
        io.disconnect();
      }, { rootMargin: '900px 0px' });
      io.observe(next);
    }

    // paginador y pastillas: al tocar o pasar por encima, antes del clic
    document.addEventListener('touchstart', function (event) {
      var link = closestLink(event.target);
      if (link) prefetch(link.getAttribute('href'));
    }, { passive: true });
    document.addEventListener('mouseover', function (event) {
      var link = closestLink(event.target);
      if (link) prefetch(link.getAttribute('href'));
    }, { passive: true });

    // menu movil: al abrirse, las primeras colecciones del menu
    var drawer = document.getElementById('MenuDrawer');
    if (drawer && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        if (!drawer.hasAttribute('open')) return;
        var links = drawer.querySelectorAll('a.menu-drawer__item-link[href*="/collections/"]');
        for (var i = 0; i < links.length && i < MENU_LINKS; i += 1) prefetch(links[i].getAttribute('href'));
        observer.disconnect();
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
